import { useIsMutating } from '@tanstack/react-query';
import { useFeatureFlag } from '@mews/framework';
import { getRepositoryQueryKey, useRepositoryMutation } from '@mews-commander/data-access';
import { FeatureFlag } from '@mews-commander/enums';

export const useAuthorizationCheck = (onSuccess: () => void) => {
    const actionAutorizationTokenEnabled = useFeatureFlag(FeatureFlag.actionAutorizationTokenEnabled);
    const checkActionValidity = useRepositoryMutation('users', 'checkActionValidity');

    return actionAutorizationTokenEnabled ? () => checkActionValidity.mutate({}, { onSuccess }) : onSuccess;
};

export const useIsCheckingAuthValidity = () => {
    const isCheckingActionValidity = useIsMutating({
        mutationKey: getRepositoryQueryKey('users', 'checkActionValidity'),
    });

    return !!isCheckingActionValidity;
};
